import axios from 'axios';
import * as actionTypes from './actionTypes';

export function getWeather() {
  return dispatch => {
    dispatch({ type: actionTypes.FETCH_WEATHER_REQUEST });
    const url =
      'https://api.openweathermap.org/data/2.5/forecast?q=Sousse,TN&units=metric&appid=6c3bdc3338b040e3eac2036dbc6ac321';
    axios
      .get(url)
      .then(res => {
        const dayOne = bringWeatherDay(res.data.list, 0, 4);
        const dayTwo = bringWeatherDay(res.data.list, 4, 12);
        const dayThree = bringWeatherDay(res.data.list, 12, 20);
        const dayFour = bringWeatherDay(res.data.list, 20, 28);
        const dayFive = bringWeatherDay(res.data.list, 28, 36);
        const daySix = bringWeatherDay(res.data.list, 36, 40);
        dispatch({
          type: actionTypes.FETCH_WEATHER_SUCCESS,
          payload: {
            weather: res.data,
            dayOne: [...dayOne],
            dayTwo: [...dayTwo],
            dayThree: [...dayThree],
            dayFour: [...dayFour],
            dayFive: [...dayFive],
            daySix: [...daySix],
          },
        });
      })
      .catch(e => {
        dispatch({ type: actionTypes.FETCH_WEATHER_FAILURE, payload: e });
      });
  };
}

function bringWeatherDay(list, begin, end) {
  return list.slice(begin, end);
}



// WEBPACK FOOTER //
// ./src/actions/weather.js